import { useContext, useEffect } from 'react'

import AppContext from '@/context/AppContext'
import { isTokenExpired as isCustomerTokenExpired } from '@/helpers'

const useRecoveryToken = () => {
  const { context } = useContext(AppContext)
  const token = context.orderRecovery.token

  const hasToken = Boolean(token)
  const isTokenExpired = hasToken && isCustomerTokenExpired(token)

  useEffect(() => {
    if (!hasToken || isTokenExpired) return

    localStorage.jwt = token
  }, [hasToken, isTokenExpired, token])

  return { hasToken, isTokenExpired }
}

export default useRecoveryToken
